export default function SubsidyIntroduction() {
  const subsidies = [
    {
      category: '助成金制度',
      subtitle: '返済不要・採用・育成・働き方改革に活用',
      color: 'from-orange-500 to-orange-600',
      items: [
        {
          name: 'キャリアアップ助成金',
          subtitle: '正社員化コース',
          amount: '1人あたり最大80万円',
          description: '非正規社員を正社員へ転換する企業を支援。待遇改善、人材定着、採用強化に直結します。',
          features: ['非正規→正社員化', '昇給・キャリア制度の整備', '定着率の向上'],
          target: '採用が難しい業種・従業員が定着しない企業',
          icon: 'ri-user-star-line'
        },
        {
          name: '人材開発支援助成金',
          subtitle: 'リスキリングコース',
          amount: '1人あたり最大50万円以上',
          description: '従業員のスキルアップ・リスキリング（学び直し）に活用。研修期間中の賃金も一部助成されます。',
          features: ['社内研修・外部研修', '広告運用、IT、管理職研修', '研修期間中の賃金助成'],
          target: 'IT化、DX推進、人材育成に力を入れたい企業',
          icon: 'ri-graduation-cap-line'
        },
        {
          name: '業務改善助成金',
          subtitle: '賃上げ × 設備導入',
          amount: '最大600万円',
          description: '最低賃金アップに取り組む企業が、生産性向上を目的とした設備導入を行う際に活用できます。',
          features: ['勤怠システム・POSレジ導入', '業務改善設備', '自動化ツール'],
          target: '業務効率化、デジタル化、店舗運営改善を進めたい企業',
          icon: 'ri-settings-3-line'
        },
        {
          name: '働き方改革推進支援助成金',
          subtitle: '',
          amount: '最大920万円',
          description: '労働時間短縮や、有給休暇取得を促進するための制度です。',
          features: ['勤怠管理システム導入', '休暇制度整備', '生産性向上設備'],
          target: '働き方改革を前進させたい企業・労務管理の見直しをしたい企業',
          icon: 'ri-time-line'
        }
      ]
    },
    {
      category: '補助金制度',
      subtitle: '大型投資・新規事業・デジタル化に活用',
      color: 'from-blue-900 to-blue-700',
      items: [
        {
          name: '小規模事業者持続化補助金',
          subtitle: '',
          amount: '最大200万円',
          description: '小規模事業者の販路拡大・集客強化を支援する制度です。',
          features: ['ホームページ制作', '広告運用', 'チラシ・動画制作', '店舗改装'],
          target: '集客を伸ばしたい・広告を強化したい小規模事業者',
          icon: 'ri-store-2-line'
        },
        {
          name: 'IT導入補助金',
          subtitle: '',
          amount: '最大450万円',
          description: 'ITツール導入に使える補助金で、どの企業でも利用しやすい万能型の制度です。',
          features: ['業務システム', '予約ツール', 'CRM/SFA', 'ECサイト制作'],
          target: '業務の効率化・自動化を進めたい企業',
          icon: 'ri-computer-line'
        },
        {
          name: 'ものづくり補助金',
          subtitle: '',
          amount: '最大4,000万円',
          description: '生産性の向上、新製品の開発、大型設備導入などに利用できる代表的な大型補助金です。',
          features: ['工作機械・製造設備', '新規プロダクト開発', 'DX設備'],
          target: '設備投資・新規事業・製造工程の改善に取り組む企業',
          icon: 'ri-tools-line'
        },
        {
          name: '事業再構築補助金',
          subtitle: '',
          amount: '最大9,000万円',
          description: '新規事業・事業転換・大型設備投資などに使える、非常に規模の大きい補助金です。',
          features: ['新規店舗開設', '新規ビジネスモデル', '新商品・新サービス', '大規模な設備導入'],
          target: '大きな事業転換や新規プロジェクトに挑戦したい企業',
          icon: 'ri-rocket-line'
        }
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-gradient-to-r from-blue-900 to-orange-500 text-white px-6 py-2 rounded-full mb-6 font-bold">
            制度のご紹介
          </div>
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            助成金・補助金制度の一部をご紹介
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            企業の"実益"につながる制度を厳選してご案内します。<br />
            補助金・助成金は、事業計画、設備投資、人材育成、働き方改革など、<br />
            企業の成長にさまざまな形で活用できる制度です。
          </p>
        </div>

        <div className="space-y-20">
          {subsidies.map((section, sectionIdx) => (
            <div key={sectionIdx}>
              <div className="text-center mb-12">
                <div className={`inline-block bg-gradient-to-r ${section.color} text-white px-8 py-3 rounded-2xl mb-3`}>
                  <h4 className="text-2xl font-bold">{section.category}</h4>
                </div>
                <p className="text-gray-600 font-medium">{section.subtitle}</p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {section.items.map((item, itemIdx) => (
                  <div 
                    key={itemIdx}
                    className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
                  >
                    <div className={`bg-gradient-to-r ${section.color} p-6 text-white`}>
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex-1">
                          <h5 className="text-2xl font-bold mb-1">{item.name}</h5>
                          {item.subtitle && (
                            <div className="text-sm opacity-90">{item.subtitle}</div>
                          )}
                        </div>
                        <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center flex-shrink-0 ml-4">
                          <i className={`${item.icon} text-3xl`}></i>
                        </div>
                      </div>
                      <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2 inline-block">
                        <div className="text-sm opacity-90 mb-1">受給額</div>
                        <div className="text-xl font-bold">{item.amount}</div>
                      </div>
                    </div>

                    <div className="p-6">
                      <p className="text-gray-700 leading-relaxed mb-6">
                        {item.description}
                      </p>

                      <div className="mb-6">
                        <div className="flex items-center gap-2 mb-3">
                          <i className="ri-check-line text-blue-900"></i>
                          <span className="font-bold text-gray-900">主な活用例</span>
                        </div>
                        <div className="space-y-2">
                          {item.features.map((feature, featureIdx) => (
                            <div key={featureIdx} className="flex items-start gap-2">
                              <i className="ri-arrow-right-s-line text-orange-500 mt-1 flex-shrink-0"></i>
                              <span className="text-gray-700 text-sm">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="bg-gradient-to-br from-blue-50 to-orange-50 rounded-xl p-4">
                        <div className="flex items-start gap-2">
                          <i className="ri-lightbulb-line text-orange-500 mt-1 flex-shrink-0"></i>
                          <div>
                            <div className="text-xs text-gray-600 mb-1">こんな企業に</div>
                            <div className="text-sm font-medium text-gray-900">{item.target}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-br from-blue-900 to-blue-950 rounded-3xl p-12 text-white">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-hand-heart-line text-3xl text-blue-900"></i>
              </div>
              <h4 className="text-3xl font-bold mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                TOKAN補助金コンサルタントが行うこと
              </h4>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8">
              <p className="text-blue-100 leading-relaxed mb-6">
                これらの制度は種類が多く、条件も複雑なため、<br />
                <strong className="text-white">「どれが自社に合っているのか？」</strong><br />
                <strong className="text-white">「どの順番で申請するべきか？」</strong><br />
                <strong className="text-white">「どの制度と組み合わせるべきか？」</strong><br />
                と悩まれる企業が非常に多いのが現状です。
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mb-8">
              {[
                { icon: 'ri-search-line', text: '制度選定（御社の状況に合うものを厳選）' },
                { icon: 'ri-puzzle-line', text: '補助金・助成金の組み合わせ提案' },
                { icon: 'ri-file-edit-line', text: '申請書作成サポート' },
                { icon: 'ri-shield-check-line', text: '契約書・内容証明などの法務サポート' },
                { icon: 'ri-pages-line', text: 'LP制作（補助金を活用した集客導線づくり）' }
              ].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-xl p-4">
                  <div className="w-10 h-10 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-blue-900 text-xl`}></i>
                  </div>
                  <span className="font-medium">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="text-center bg-gradient-to-r from-yellow-400 to-orange-400 rounded-2xl p-6">
              <div className="text-blue-900 font-bold text-xl mb-2">
                補助金 × 法務 × LP制作
              </div>
              <p className="text-blue-900 font-medium">
                これらが一つにまとまった唯一のサービスとして、<br />
                御社の負担を最小限にしながら最大の成果を目指します。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
